import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import { UserDataProvider } from "../components/UserDataContext";
import { UserProvider } from "../components/UserContext";
import { SearchProvider } from "../components/SearchContext";

import theme from "../theme";

export default function AppProviders({ children }) {
  return (
    <UserDataProvider>
      <UserProvider>
        <SearchProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </SearchProvider>
      </UserProvider>
    </UserDataProvider>
  );
}
